import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import ForecastView from '@/components/forecast/forecast-view'
import { loadCrmPageProps } from '@/lib/crm-page'
import { nextFirstQuarter } from '@/lib/dates'

type Q1ForecastPageProps = Partial<CrmPageProps> & {
    quarter: string
    label: string
}

const Q1ForecastPage: FC<Q1ForecastPageProps> = ({ data, today, quarter, label }): ReactNode => {
    return (
        <AppShell data={data} today={today ?? ''} title="Q1 forecast" description={`Forecast for ${label} by stage, month and owner.`}>
            <PageHeader title={`${label} Forecast`} />
            <ForecastView initialQuarter={quarter} />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<Q1ForecastPageProps> = async () => {
    const props = await loadCrmPageProps()
    const quarter = nextFirstQuarter(props.today)

    return { props: { ...props, quarter: quarter.key, label: quarter.label } }
}

export default Q1ForecastPage
